angular.module('components.createResellerReturnOrderArticlesOverview', [])
    .component('createResellerReturnOrderArticlesOverview', {
        templateUrl: 'main/resellerorder/resellerreturnordermodify/components/articlelist_overview.component.tpl.html',
        controllerAs: 'vm',
        bindings: {
            resellerOrder: '=',
            disabled: '<',
            onArticleSelected: '&',
            onLineItemChanged: '&'
        },
        controller: ['$scope', '$state', '$window', '$translate', 'confirmationDialogService', controller]
    });

// @ngInject
function controller($scope, $state, $window, $translate, confirmationDialogService) {
    var vm = this;
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.$onDestroy = onDestroy;

    //Properties
    vm.lineItemsGroupedByArticle = [];

    //Methods
    vm.viewOrderArticle = viewOrderArticle;
    vm.absolute = absolute;
    vm.groupBy = groupBy;
    vm.saveLineItem = saveLineItem;
    vm.canModifyLineItem = canModifyLineItem;
    vm.toggleExpandAll = toggleExpandAll;
    vm.removeArticleFromOrder = removeArticleFromOrder;
    vm.canDeleteArticleFromOrder = canDeleteArticleFromOrder;
    vm.getStatusTranslation = getStatusTranslation;
    vm.getProductGrossPriceSum = getProductGrossPriceSum;
    vm.getTotalGrossPriceSum = getTotalGrossPriceSum;
    vm.getProductGrossPrice = getProductGrossPrice;
    vm.getProductQuantitySum = getProductQuantitySum;
    vm.getTotalQuantitySum = getTotalQuantitySum;
    vm.getProductUnfulfilledQuantitySum = getProductUnfulfilledQuantitySum;
    vm.getFinalAmount = getFinalAmount;
    vm.goToProduct = goToProduct;

    function onInit() {
        if (vm.resellerOrder.lineItems === undefined) {
            vm.resellerOrder.lineItems = [];
        } else {
            regroupLineItems();
        }

        $scope.$watch(function () { return vm.resellerOrder.lineItems.length; }, function (newValue, oldValue) {
            if (newValue !== oldValue) {
                regroupLineItems();
            }
        });
    }
    function onChanges() {
    }
    function onDestroy() {
    }

    function goToProduct(articleId) {
        var url = $state.href('product.articles.article', {articleId: articleId});
        $window.open(url,'_blank');
    }

    function getFinalAmount(lineItem) {
        var discountPercent = lineItem.discountPercent ? lineItem.discountPercent : 0;
        return lineItem.amount * (1 - discountPercent);
    }

    function getProductUnfulfilledQuantitySum(article) {
        var sumQty = 0;
        sumQty += _.sumBy(article.lineItems, function(li) {
            return li.fulfilledQuantity;
        });
        return sumQty;
    }

    function getProductGrossPriceSum(article) {
        var sumPrice = 0;
        sumPrice += _.sumBy(article.lineItems, function(li) {
            return li.amount * li.quantity;
        });
        return sumPrice;
    }

    function getTotalGrossPriceSum() {
        var sumPrice = 0;
        _.forEach(vm.lineItemsGroupedByArticle, function(o) {
            sumPrice += getProductGrossPriceSum(o);
        });
        return sumPrice;
    }

    function getProductGrossPrice(article) {
        var sumPrice = 0, sumTotalQuantity = 0;
        sumPrice += _.sumBy(article.lineItems, function(li) {
            sumTotalQuantity += li.quantity;
            return li.amount * li.quantity;
        });
        return sumPrice / (sumTotalQuantity === 0 ? 1 : sumTotalQuantity);
    }

    function getProductQuantitySum(article) {
        var sumQty = 0;
        sumQty += _.sumBy(article.lineItems, function(li) {
            return li.quantity;
        });
        return sumQty;
    }

    function getTotalQuantitySum() {
        var sumQty = 0;
        _.forEach(vm.lineItemsGroupedByArticle, function(o) {
            sumQty += getProductQuantitySum(o);
        });
        return sumQty;
    }

    function getStatusTranslation(text) {
        if (text) {
            var textCapital = text.substr(0, 1).toUpperCase() + text.substr(1, text.length - 1);
            return $translate.instant('resellerorder.status' + textCapital);
        }
    }

    function removeArticleFromOrder(article) {
        if (!article) { return false; }

        confirmationDialogService.showDialog($translate.instant('resellerorder.confirmRemoveArticle'), $translate.instant('common.warning')).then(function (result) {
            if (result === true) {
                _.forEach(article.lineItems, function(li) {
                    if (_.find(li.links, function(l) { return l.rel === 'modify'; }) !== undefined) {
                        li.quantity = 0;
                        vm.onLineItemChanged({ lineItem: li });
                    }
                });
                vm.resellerOrder.lineItems = _.filter(vm.resellerOrder.lineItems, function(o) {
                    return o.articleId !== parseInt(article.article.id);
                });
            }
        });
    }
    function canDeleteArticleFromOrder(lineItemsGroupedOnArticle) {
        if (!lineItemsGroupedOnArticle) { return false; }

        var canDelete = true;
        _.forEach(lineItemsGroupedOnArticle.lineItems, function(li) {
            if (_.find(li.links, function(l) { return l.rel === 'delete'; }) === undefined) {
                canDelete = false;
            }
        });
        return canDelete;
    }

    function toggleExpandAll() {
        var allAreExpanded = true;
        _.forEach(vm.lineItemsGroupedByArticle, function (o) {
            if (!o.article.showRows || o.article.showRows === false) {
                allAreExpanded = false;
            }
        });

        _.forEach(vm.lineItemsGroupedByArticle, function(art) {
            if (!allAreExpanded) {
                art.article.showRows = true;
            } else {
                art.article.showRows = false;
            }
        });
    }

    function canModifyLineItem(lineItem) {
        var canModifyLineItems = _.find(vm.resellerOrder.links, function(o) { return o.rel === 'upsertLineItems'; }) !== undefined;
        return canModifyLineItems;
    }

    function regroupLineItems() {
        vm.resellerOrder.lineItems = _.sortBy(vm.resellerOrder.lineItems, ['variantDetail1Name', 'variantDetail2SortOrder']);
        vm.lineItemsGroupedByArticle = _.chain(vm.resellerOrder.lineItems)
            // Group the elements of Array based on `color` property
            .groupBy('articleId')
            // `key` is group's name (color), `value` is the array of objects
            .map((value, key) => ({
                article: {
                    displayArticleNumber: value.length > 0 ? value[0].displayArticleNumber : '',
                    articleName: value.length > 0 ? value[0].articleName : '',
                    id: key,
                    showRows: false
                }, lineItems: value }))
            .value();

        _.forEach(vm.lineItemsGroupedByArticle, function(lineItemArticle) {
            _.forEach(lineItemArticle.lineItems, function(lineItem) {
                lineItem.discountDisplayPercent = lineItem.discountPercent * 100 + '%';
            });
        });
    }

    function groupBy(array, field) {
        return _.groupBy(array, field);
    }

    function saveLineItem(lineItem) {
        vm.onLineItemChanged({ lineItem: lineItem });
    }

    function viewOrderArticle(article) {
        vm.onArticleSelected({ article: article });
    }

    function absolute(number) {
        if (_.isNumber(number)) {
            return Math.abs(number);
        }
        return 0;
    }
}
